<button class="project-selector-button" [matMenuTriggerFor]="projectSelectorMenu" [ngStyle]="buttonStyle">
  @if (loadingProject) {
    <div class="oph-orange-spinner">
      <mat-spinner class="custom-color" diameter="15"></mat-spinner>
    </div>
  } @else if (selectedProject?.isChallenge) {
    <img src="assets/img/icons/projects-challenge.svg" alt="" />
  } @else {
    <div class="project-color" [style.background-color]="selectedProject?.color || '#E5E3DC'"></div>
  }
  <span class="project-name">{{ selectedProject?.label || 'Select a project' }}</span>
  <mat-icon svgIcon="chevron-down"></mat-icon>
</button>
<mat-menu #projectSelectorMenu="matMenu" class="oph-select-menu">
  <ng-content select=".project-selector"> </ng-content>
</mat-menu>

@if (!hideActionButton) {
  <div class="project-status-row">
    @if (loading) {
      <mat-spinner class="status-spinner custom-color" diameter="20"></mat-spinner>
    } @else {
      <span class="project-status-pill" [ngStyle]="statusPillStyle()">{{ buttonDisplay() }}</span>
      @if (selectedProject?.status !== 'inactive' && isProjectActive) {
        <span class="expiration-inline"
          >Exp. {{ selectedProject.endDateTime | convertUtcToTimezone: 'MMM D, YYYY' }}</span
        >
      }
    }
  </div>
}
